import {
    GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_SUCCESS,
    MERCHANT_PAYMENT_DETAIL_API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [],
    error: {},
  }

  const merchantPaymentDetail = (state = INIT_STATE, action) => {
    switch (action.type) {

      case GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
        }

      case MERCHANT_PAYMENT_DETAIL_API_ERROR:
        return {
          ...state,
          error: action.payload,
        }
  
      default:
        return state
    }
  }
  
  export default merchantPaymentDetail